module.exports = __webpack_public_path__ + "static/media/icon_instrument_upright_bass.84839d10.svg";